










































































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import LearningRequestFormCreateV2 from "@/components/learning-request-v2/LearningRequestFormCreateV2.vue";
import { learningRequestApi } from "@/getinfo-api";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { StatusProfile as IStatusProfile } from "@/api-v2/learning-requests/models";
import { StatusProfileCreate as IStatusProfileCreate } from "@/api-v2/learning-requests/models";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TableActions from "@/components/form/TableActions.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({
  components: {
    TableActions,
    CBlock,
    CustomTableCol,
    CustomTableItem,
    CustomTable,
    CustomButton,
    CField,
    CPageButtons,
    LearningRequestFormCreateV2,
    CPage
  }
})
export default class Profiles extends Vue {
  profiles: Array<IStatusProfile> = [];
  title: string = "";
  isLoading: boolean = false;

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  getProfiles() {
    this.isLoading = true;
    learningRequestApi.StatusProfiles.listProfiles(this.selectedCompanyId)
      .then(res => {
        this.profiles = res.data;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  removeProfile(id: string) {
    learningRequestApi.StatusProfiles.deleteProfile(id)
      .then(() => {
        this.getProfiles();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  editProfile(id: string) {
    this.$router.push({ name: "statusProfileEdit", params: { id: id } });
  }

  async addProfile() {
    let params: IStatusProfileCreate = {
      title: this.title,
      statuses: [
        {
          title: this.$tc(this.$translate.NotProcessed)
        }
      ],
      companyId: this.selectedCompanyId
    };
    await learningRequestApi.StatusProfiles.createProfile(params).then(res => {
      this.$router.push({
        name: "profile",
        params: { id: res.data.id }
      });
    });
  }

  created() {
    this.getProfiles();
  }
}
